import { Component } from '@angular/core';

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html'
})
export class HomeTwoComponent {}
